import { TDeviceType } from "@cian/ui-kit";

export const initialState: TDeviceType = 'desktop';

export const deviceTypeReducer = (state = initialState, action = null) => state;
